import { render, staticRenderFns } from "./stored-consum-repord.vue?vue&type=template&id=a345edd4"
import script from "./stored-consum-repord.vue?vue&type=script&lang=js"
export * from "./stored-consum-repord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports